try {
  var tabs = $(".template-product .tab");
  if (tabs != undefined) {
    var tabHeaders = $(".template-product .tab-header");
    var activeClass = "active-tab";
    tabHeaders.on("click", function () {
      var tabHeader = $(this);
      if (tabHeader.hasClass(activeClass)) {
        tabHeader.removeClass(activeClass);
        tabHeader.attr("aria-selected", false);
      } else {
        tabHeader.addClass(activeClass);
        tabHeader.attr("aria-selected", true);
      }
    });
  }
  function refreshPrice(label) {
    label.parentNode.querySelector(".form__label>span").innerText =
      label.innerText;
  }
  $("header-drawer").click(function () {
    $("#NavDrawer").addClass("js-drawer-open");
  });
  $(".js-drawer-close").click(function () {
    setTimeout(function () {
      $("#NavDrawer").removeClass("is-closing");
    }, 800);
    $("#NavDrawer").addClass("is-closing");
    $("#NavDrawer").removeClass("js-drawer-open");
    $(".header__icon--menu").attr("aria-expanded", false);
  });
  $(".slick-shop").slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
  });
} catch (error) {}

// Preventing subscriptions from having qty > 1

$(document).ready(function () {
  const isDebug = true;
  const baseStyles = [
    "color: #fff",
    "background-color: #2759e1",
    "padding: 2px 8px",
    "border-radius: 4px",
  ].join(";");
  function consoleLog() {
    if (window.console && isDebug === true) {
      console.log("%cNP", baseStyles, ...Array.prototype.slice.call(arguments));
    }
  }

  function updateLineItemQty(key, qty, callback) {
    var formData = new FormData();
    formData.append(`updates[${key}]`, qty);
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        consoleLog(`✅ Subscription qty reduced to 1, line item key "${key}"`);
        // console.log({'data': data});
        callback();
      });
  }

  function iCartSubsriptionQtyLimit(cartItems) {
    consoleLog("Checking line items for subscriptions…");
    for (let i = 0; i < cartItems.length; i++) {
      const item = cartItems[i];

      if (item?.selling_plan_allocation != null) {
        const itemQty = item?.quantity || 0;

        if (itemQty > 1) {
          consoleLog("⛔️ Subscription with qty > 1 detected, reducing…");
          const itemKey = item?.key || "";

          updateLineItemQty(itemKey, 1, () => {
            window.prepareDataForDisplayWidgetByRule();
          });
        } else {
          consoleLog("✅ Subscription with qty 1 found, continuing");
        }
      }
    }
  }

  function startup() {
    if (window.location.search.includes("test_sub_limit=true")) {
      consoleLog("FEATURE - SUBSCRIPTION LIMIT ENABLED");
      let cartOpen = false;

      // iCart event handlers
      window.addEventListener("icartUpdateCartEvent", function (event) {
        consoleLog("icartUpdateCartEvent event triggered");
        iCartSubsriptionQtyLimit(event?.detail?.items || []);
      });
      window.addEventListener("icartAddToCartEvent", function (event) {
        consoleLog("icartAddToCartEvent event triggered");
        // note that add event just returns single item but full qty, so we check just that
        iCartSubsriptionQtyLimit([event?.detail] || []);
      });
      window.addEventListener("icartSideCartOpenEvent", function (event) {
        if (cartOpen === false) {
          consoleLog("icartSideCartOpenEvent event triggered");
          iCartSubsriptionQtyLimit(event?.detail?.items || []);
        }
        cartOpen = true;
      });
      window.addEventListener("icartSideCartCloseEvent", function (event) {
        consoleLog("icartSideCartCloseEvent event triggered");
        cartOpen = false;
      });

      // Cart page event handlers
      window.addEventListener("cartUpdateCartEvent", function (event) {
        consoleLog("cartUpdateCartEvent event triggered", event);
        // iCartSubsriptionQtyLimit(event?.detail?.items || []);
      });
    }
  }

  startup();
});
